// API client for the AI write-approval queue (the "AI Actions" tab). Proposals
// are created by the MCP propose_write tool; admins list and approve/reject them
// here. Approve/reject are bulk by id so a single button can act on a checkbox
// selection.
import { api } from './api.js';

// listAIActions returns proposals newest-first. Pass status to filter (e.g.
// 'pending'); omit for all recent actions.
export const listAIActions = (status) =>
  api.get('/api/ai-actions' + (status ? `?status=${encodeURIComponent(status)}` : ''))
    .then((r) => r.actions || []);

// approveAIActions approves + EXECUTES the given ids; returns per-id results.
export const approveAIActions = (ids) =>
  api.post('/api/ai-actions/approve', { ids }).then((r) => r.results || []);

// rejectAIActions rejects the given ids (they never run).
export const rejectAIActions = (ids) =>
  api.post('/api/ai-actions/reject', { ids }).then((r) => r.results || []);

// holdAIActions pins (held=true) or unpins (held=false) the given pending ids so
// the pending-TTL sweep skips them — parking a proposal instead of letting it expire.
export const holdAIActions = (ids, held) =>
  api.post('/api/ai-actions/hold', { ids, held }).then((r) => r.results || []);

// normConfig folds a config response into a stable shape.
const normConfig = (r) => ({ bypassApproval: !!r.bypassApproval, ttlHours: Number(r.ttlHours) || 24 });

// getAIActionsConfig reads the admin-global settings: the "bypass approval"
// toggle (when on, MCP-proposed writes auto-execute) and the pending TTL in hours.
export const getAIActionsConfig = () =>
  api.get('/api/ai-actions/config').then(normConfig);

// setAIActionsConfig applies a partial update. Pass any subset of
// { bypassApproval, ttlHours }; omitted fields are left unchanged.
export const setAIActionsConfig = (patch) =>
  api.put('/api/ai-actions/config', patch).then(normConfig);

// listMCPRuns returns the MCP queries currently waiting for a connection or
// running on a server (oldest first): [{id, state, stopping, username,
// connectionName, database, sql, threadId, elapsedMs}].
export const listMCPRuns = () => api.get('/api/mcp-runs').then((r) => r.runs || []);

// stopMCPRun KILLs a running MCP query (or drops a waiting one).
export const stopMCPRun = (id) => api.post(`/api/mcp-runs/${id}/stop`, {});
